"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlignCss = void 0;
const getAlignCss = (themeId) => {
    return `
    .${themeId} .align-left{
      text-align: left !important;
    }
    .${themeId} .align-center{
      text-align: center !important;
    }
    .${themeId} .align-right{
      text-align: right !important;
    }
  `;
};
exports.getAlignCss = getAlignCss;
